import { DIGITS_ONLY_REGEX, LETTERS_ONLY_REGEX } from "@unreserved/configs";
import { z } from "zod";

export const publicInspectionSchema = z.object({
    email: z.string().min(1, "Email is required").email("Invalid email address"),
    name: z
        .string()
        .trim()
        .min(1, "Name is required")
        .max(100, "Full name must be less than 100 characters")
        .regex(LETTERS_ONLY_REGEX, "Full name can only contain letters and spaces"),
    countryCode: z.string().optional(),
    phoneNumber: z
        .string()
        .max(15, "Phone number must be less than 15 digits")
        .regex(DIGITS_ONLY_REGEX, "Phone number can only contain digits")
        .optional()
        .or(z.literal("")),
    propertyAddress: z.string().min(1, "Property address is required"),
    selectedDate: z.date({ required_error: "Please select a date" }),
    selectedTime: z.string().min(1, "Time is required"),
});

export type PublicInspectionFormData = z.infer<typeof publicInspectionSchema>;
